// stores/requestTracker.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface TrackedRequest {
  id: string
  type: 'fetch' | 'img' | 'video'
  url: URL
  method: string
  headers?: string
  start?: Date,
  body?: string
  state: 'pending' | 'error' | 'success'
  progress: number
  response?: Response
  error?: Error
  end?: Date
}

export const useRequestTrackerStore = defineStore('requestTracker', () => {
  const requests = ref<TrackedRequest[]>([]);
  const abortControllers = new Map<string, AbortController>();

  function addRequest(req: TrackedRequest) {
    if (abortControllers.has(req.id)) {
      throw new Error('Duplicate request ID: ' + req.id + '');
    }
    requests.value.push({
 start: new Date(),
...req,
});
    getAbortController(req.id);
  }

  function updateRequest(id: string, updates: Partial<TrackedRequest>) {
    const req = requests.value.find((r) => r.id === id);
    if (req) Object.assign(req, updates);
  }

  function finishedRequest(id: string, response: Response) {
    updateRequest(id, {
 state: 'success',
end: new Date(),
response,
});
    setTimeout(() => removeRequest(id), 2000);
  }

  function failedRequest(id: string, error: Error) {
    updateRequest(id, {
 state: 'error',
end: new Date(),
error,
});
    setTimeout(() => removeRequest(id), 2000);
  }

  function removeRequest(id: string) {
    requests.value = requests.value.filter((r) => r.id !== id);
    abortControllers.delete(id);
  }

  function getAbortController(id: string): AbortController {
    return abortControllers.get(id) ?? (abortControllers.set(id, new AbortController()).get(id) as AbortController);
  }

  function abortRequest(id: string) {
    getAbortController(id).abort();
  }

  return {
    requests,
    addRequest,
    updateRequest,
    finishedRequest,
    failedRequest,
    removeRequest,
    abortRequest,
    getAbortController,
  };
});
